import { digger } from '@cbre/digger';
import { concatValuesBy, defaultTxt } from '@miq/utils';
import { ReportRecord } from '../../../models/report.model';
import { TemplateFieldsDisplayFn } from '../../../models/template.model';
import { getMediaInformation } from '../templates-formatter.const';
import { sortAttributesByFieldId } from '../utils/argument-sorting';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../utils/dynamic-data-retrievers';
import { AvailabilityTypesLabels, getFloorAndSuite, getFloorPlanImageSlide } from './common';

export const displayFnMap: TemplateFieldsDisplayFn = {
  17839: {
    displayFn: (record: ReportRecord, options, ...args) => {
      const finalArgs = sortAttributesByFieldId(options.locale, args, 27);
      const values = finalArgs.map(arg => mapAndFormatDynamicValue(record, arg));
      return concatValuesBy(', ', ...values);
    },
    routeFn: ({ data: entityRecord }: ReportRecord) => {
      return ['/records', 'property', digger(entityRecord, 'property.id'), 'details'];
    },
  },
  49: {
    displayFn: (record: ReportRecord, _options, arg1, arg2) => {
      const values = concatValuesBy(
        defaultTxt,
        mapAndFormatDynamicValue(record, arg1),
        mapAndFormatDynamicValue(record, arg2)
      );
      return values;
    },
  },
  78: { displayFn: displayFnWrapper },
  882: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return mapAndFormatDynamicValue(record, arg, null, null, false);
    },
  },
  883: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return mapAndFormatDynamicValue(record, arg, null, true, false);
    },
  },
  884: {
    displayFn: (record: ReportRecord, _options, suite, floor) => {
      const suiteVal = mapAndFormatDynamicValue(record, suite, null, null, false);
      const floorNumberVal = mapAndFormatDynamicValue(record, floor, null, null, false);
      const result = (suiteVal as string[]).map((val, i) => concatValuesBy('/', val, floorNumberVal[i]));
      return result;
    },
  },
  885: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return mapAndFormatDynamicValue(record, arg, null, true, false);
    },
  },
  886: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return mapAndFormatDynamicValue(record, arg, null, true, false);
    },
  },
  887: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return mapAndFormatDynamicValue(record, arg, null, null, false);
    },
  },
  259: {
    displayFn: (record: ReportRecord, _, availableType) => {
      const availableTypeVal = mapAndFormatDynamicValue(record, availableType) as string;
      const result = !!AvailabilityTypesLabels[availableTypeVal] ? AvailabilityTypesLabels[availableTypeVal] : '-';
      return result;
    },
  }, // title based on availability Type
  99: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, // Additional Image
  254: {
    displayFn: (record: ReportRecord) => {
      return getMediaInformation(record);
    },
  }, // Secondary Image
  ...getFloorPlanImageSlide(),
  ...getFloorAndSuite(),
};
